import type { NodeViewRenderers } from 'ricos-types';
import { Node_Type } from 'ricos-types';

import Poll from './poll';

export const nodeViewRenderers: Partial<NodeViewRenderers> = {
  [Node_Type.POLL]: Poll,
};
